jQuery(document).ready(function($) {
  var animatedScroll = {
    init: function () {
      // Select all links with hashes
      $('a[href*="#"]')
        // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .not('.tab')
        .click(function (event) {
          // On-page links
          if (
            location.pathname.replace(/^\//, "") ==
            this.pathname.replace(/^\//, "") &&
            location.hostname == this.hostname
          ) {
              // Figure out element to scroll to
              var target = $(this.hash);
              target = target.length
              ? target
              : $("[name=" + this.hash.slice(1) + "]");
              // Does a scroll target exist?
              if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                $("html, body").animate({
                  scrollTop: target.offset().top - 100,
                },1000,
                function() {
                  // Callback after animation
                  // Must change focus!
                  var $target = $(target);
                  $target.focus();
                  if ($target.is(":focus")) {
                    // Checking if the target was focused
                    return false;
                  } else {
                    $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                    $target.focus(); // Set focus again
                  }
                }
                );
              }
            }
        }
      );
    },
  };

  
  $('.single-news__main-wrapper:not(.project)').each(function(){
      var tocs = '<div class="toc"><div class="toc__section-title">In this Article</div><div class="toc__wrapper"></div></div>';

      //add ID to each header automatically.
      $(this).find(":header").each(function(index){
        if ( $(this).attr('ID') == null ) {
          $(this).attr('ID','heading_' + index);
        }

        // insert frame for toc to the first heading
        if ( index == 0 ) {
          $(this).before(tocs);
        }

        //get all header
        var toc_id = $(this).attr('ID'),
            toc_text = $(this).text(),
            toc_link = '<a class="toc__link" href="#' + toc_id + '">' + toc_text +'</a>';
        if ( toc_text != '') {
          $('.toc__wrapper').append(toc_link);
        }
      });
      animatedScroll.init();      
  });

});